import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faQuestionCircle, faInfoCircle, faCheckCircle, faTimes, faSync } from '@fortawesome/free-solid-svg-icons';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirmación", 
    message = "¿Estás seguro de realizar esta acción?", 
    confirmText = "Confirmar", 
    cancelText = "Cancelar",
    type = "warning", // warning, danger, info, success
    isLoading = false
}) => {
    if (!isOpen) return null;

    const icons = {
        warning: faExclamationTriangle,
        danger: faExclamationTriangle,
        info: faInfoCircle,
        success: faCheckCircle,
        question: faQuestionCircle
    };

    const colors = {
        warning: "text-warning",
        danger: "text-danger",
        info: "text-info",
        success: "text-success",
        question: "text-primary"
    };

    const btnColors = {
        warning: "btn-warning",
        danger: "btn-danger",
        info: "btn-info",
        success: "btn-success",
        question: "btn-primary"
    };

    return (
        <div className="ink-modal-overlay animate__animated animate__fadeIn">
            <div className="ink-modal confirmation-modal animate__animated animate__zoomIn animate__faster">
                <button className="ink-modal-close-btn" onClick={onClose} disabled={isLoading}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                
                <div className="p-4 text-center">
                    <div className={`mb-3 fs-1 ${colors[type] || 'text-warning'}`}>
                        <FontAwesomeIcon icon={icons[type] || faExclamationTriangle} />
                    </div>
                    
                    <h3 className="text-white mb-2">{title}</h3>
                    <p className="text-white-50 mb-4">{message}</p>
                    
                    <div className="d-flex justify-content-center gap-3">
                        <button 
                            className="btn btn-outline-secondary px-4 py-2 rounded-pill transition-all" 
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            {cancelText}
                        </button>
                        <button 
                            className={`btn ${btnColors[type] || 'btn-primary'} px-4 py-2 rounded-pill shadow-sm transition-all d-flex align-items-center gap-2`} 
                            onClick={onConfirm}
                            disabled={isLoading}
                        >
                            {isLoading && <FontAwesomeIcon icon={faSync} spin />}
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
